import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { getID } from "src/libs/utilities"
import { LANDING_TYPE_CONTENT } from "../interfaces"

 

export const personalCards = () : any[] => {
    return [
        {
          "id": getID( "personal_cards" ),
          "type": "personal_cards",
          columns: 3,
          "order": [
            "avatar",
            "order",
            "first_name",
            "last_name",
            "description",
            "roles",
            "statistic_line",
            "links"
          ],
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "feedType": "carousel",
          "design_type": 2,
          "cards": [
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/f6/6d/a6/f66da646f9f6d37024f0ca275d15ba09.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "first_name": { "data": "Мустандил Исакович" },
              "last_name": { "data": "Пляйстнер" },
              "roles": {
                "data": [
                  { "_id": "8-11-11", "title": "Нежданчик" },
                  { "_id": "8-11-1134", "title": "Барин-сударин" }
                ]
              },
              "description": {
                "data": "В этом человеке что-то есть. Прекрасно понимает, что ему объявили войну. И Запад через свою пятую колонну жмёт ему на тормоза."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [32, 6, 98, 26] }
            },
            {
              "id": getID( "" ),
              "avatar": {
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/17/21/12/172112d7e438eb485655dd23110d2a3d.jpg"
              },
              "first_name": { "data": "Авдотья" },
              "last_name": { "data": "Пурпышкина" },
              "roles": {
                "data": [
                  { "_id": "8-11", "title": "Колдовская колдунька" },
                  { "_id": "8-11-77", "title": "Барыня-сударыня" }
                ]
              },
              "description": {
                "data": "Женское обаяние 12 уровня. Во-первых, проверит паспорт. Потом даст пропуск. Я-то знаю... Положа руку на сердцЕ."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { "data": [48, 42, 87, 93] }
            },
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/1200x/e6/52/d4/e652d435d75040a0ba0b6b5802e66e9e.jpg"
              },
              "first_name": { "data": "Дед Пердед" },
              "last_name": { "data": "Шелковистов" },
              "roles": { "data": [{ "_id": "8-11", "title": "Конторщик" }] },
              "description": {
                "data": "Ловелас и проныра. На прошлом эфире сообщил публике о своей помолвке. Сложная система компромиссов с его дамой сердца достигнута. Наконец-то мы все вздохнём с облегчением."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [32, 6, 98, 26] }
            },
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/1200x/9c/07/17/9c0717873227bbac64c15b84b3802e3f.jpg"
              },
              "first_name": { "data": "Манихей" },
              "last_name": { "data": "Подпермышкин-Фиговинский" },
              "description": {
                "data": "Этим гражданином принято решение баллотироваться в генерал-губернаторы. Пускай Папуа вздрогнет."
              },
              "roles": { "data": [{ "_id": "8-21", "title": "Минорик" }] },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { "data": [48, 42, 87, 93] }
            }
          ],
            defaultTitle: "Компактные карточки с большым портретом"
        },
        {
          "id": getID( "personal_cards" ),
          "type": "personal_cards",
          "order": [
            "avatarMedallion",
            "first_name",
            "last_name",
            "description",
            "statistic_line", 
            "roles",
            "links"
          ],
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "feedType": "carousel",
          "is_nagination": 1,
          "design_type": 1,
          columns: 4,
          "cards": [
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/f6/6d/a6/f66da646f9f6d37024f0ca275d15ba09.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/f6/6d/a6/f66da646f9f6d37024f0ca275d15ba09.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "first_name": { "data": "Мустандил Исакович" },
              "last_name": { "data": "Пляйстнер" },
              "roles": {
                "data": [
                  { "_id": "8-11-11", "title": "Нежданчик" },
                  { "_id": "8-11-1134", "title": "Барин-сударин" }
                ]
              },
              "description": {
                "data": "В этом человеке что-то есть. Прекрасно понимает, что ему объявили войну. И Запад через свою пятую колонну жмёт ему на тормоза."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [32, 6, 98, 26] }
            },
            {
              "id": getID( "" ),
              "avatar": {
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/17/21/12/172112d7e438eb485655dd23110d2a3d.jpg"
              },
              "first_name": { "data": "Авдотья" },
              "last_name": { "data": "Пурпышкина" },
              "roles": {
                "data": [
                  { "_id": "8-11", "title": "Колдовская колдунька" },
                  { "_id": "8-11-77", "title": "Барыня-сударыня" }
                ]
              },
              "description": {
                "data": "Женское обаяние 12 уровня. Во-первых, проверит паспорт. Потом даст пропуск. Я-то знаю... Положа руку на сердцЕ."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { "data": [48, 42, 87, 93] }
            },
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/1200x/e6/52/d4/e652d435d75040a0ba0b6b5802e66e9e.jpg"
              },
              "first_name": { "data": "Дед Пердед" },
              "last_name": { "data": "Шелковистов" },
              "roles": { "data": [{ "_id": "8-11", "title": "Конторщик" }] },
              "description": {
                "data": "Ловелас и проныра. На прошлом эфире сообщил публике о своей помолвке. Сложная система компромиссов с его дамой сердца достигнута. Наконец-то мы все вздохнём с облегчением."
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [32, 6, 98, 26] }
            },
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/1200x/9c/07/17/9c0717873227bbac64c15b84b3802e3f.jpg"
              },
              "first_name": { "data": "Манихей" },
              "last_name": { "data": "Подпермышкин-Фиговинский" },
              "description": {
                "data": "Этим гражданином принято решение баллотироваться в генерал-губернаторы. Пускай Папуа вздрогнет."
              },
              "roles": { "data": [{ "_id": "8-21", "title": "Минорик" }] },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { "data": [48, 42, 87, 93] }
            },
            {
              "id": getID( "" ),
              "avatarMedallion": {
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "avatar": {
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/00/a5/9f/00a59f8bf6f5d71e46a3f96d970e73c7.jpg"
              },
              "description": {
                "data": "американский киноактёр. Американский институт киноискусства назвал Бугурда лучшим актёром в истории американского кино. Сменив несколько занятий, в 1921 году Бугурд стал актёром"
              },
              "first_name": { "data": "Хамфри" },
              "last_name": { "data": "Бугурд" },
              "divider": {},
              "roles": {
                "data": [
                  { "_id": "8-31", "title": "Актёр" },
                  { "_id": "8-32", "title": "Мастадонт" },
                  { "_id": "8-33", "title": "Коллекционер суккулентов" }
                ]
              },
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [99, 11, 43, 65] }
            },
            {
              "id": getID( "" ),
              "avatar": {
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "avatarMedallion": {
                "data": "https://i.pinimg.com/736x/80/41/e5/8041e5e7c35428de032d657961f63c15.jpg"
              },
              "background": {
                "data": "https://i.pinimg.com/736x/ee/06/8a/ee068ac2a400dae766f93268f8fc8dd6.jpg"
              },
              "description": {
                "data": "На Валдае неадекватно отреагировала на вызов, что вызвало удивление. Ещё чего-то -- натравила народ на всю австралийскую колбасу."
              },
              "first_name": { "data": "Жермондина" },
              "last_name": { "data": "Кудахткина" },
              "roles": {
                "data": [
                  { "_id": "8-11", "title": "Клошарик-1" },
                  { "_id": "8-11-4", "title": "Шераховатый" }
                ]
              },
              "divider": {},
              "links": {
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { "data": [99, 11, 43, 65] }
            }
          ],
            defaultTitle: "Компактные карточки с медальоном"
        },
        {
          "id":  getID( "personal_cards" ),
          "type": "personal_cards",
          "order": [
            "background",
            "order",
            "first_name",
            "last_name",
            "description",
            "links",
            "roles"
          ],
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "feedType": "carousel",
          "design_type": 4,
          columns: 4,
          "cards": [
            {
              "id":  getID( "card" ),
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Мустандил Исакович" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Пляйстнер" 
              },
              "roles": {
                "id":  getID( "" ),
                "data": [
                  { "_id": "8-11-11", "title": "Нежданчик" },
                  { "_id": "8-11-1134", "title": "Барин-сударин" }
                ]
              },
              "description": {
                "id":  getID( "" ),
                "data": "В этом человеке что-то есть. Прекрасно понимает, что ему объявили войну. И Запад через свою пятую колонну жмёт ему на тормоза."
              },
              "divider": {
                "id":  getID( "" ),
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [32, 6, 98, 26] 
              }
            },
            {
              "id":  getID( "card" ),
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/17/21/12/172112d7e438eb485655dd23110d2a3d.jpg"
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Авдотья" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Пурпышкина" 
              },
              "roles": {
                "id":  getID( "" ),
                "data": [
                  { "_id": "8-11", "title": "Колдовская колдунька" },
                  { "_id": "8-11-77", "title": "Барыня-сударыня" }
                ]
              },
              "description": {
                "id":  getID( "" ),
                "data": "Женское обаяние 12 уровня. Во-первых, проверит паспорт. Потом даст пропуск. Я-то знаю... Положа руку на сердцЕ."
              },
              "divider": {
                "id":  getID( "" ),
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [48, 42, 87, 93] 
              }
            },
            {
              "id":  getID( "card" ),
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/e6/52/d4/e652d435d75040a0ba0b6b5802e66e9e.jpg"
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Дед Пердед" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Шелковистов" 
              },
              "roles": { 
                "id":  getID( "" ),
                "data": [{ "_id": "8-11", "title": "Конторщик" }] 
              },
              "description": {
                "id":  getID( "" ),
                "data": "Ловелас и проныра. На прошлом эфире сообщил публике о своей помолвке. Сложная система компромиссов с его дамой сердца достигнута. Наконец-то мы все вздохнём с облегчением."
              },
              "divider": {
                "id":  getID( "" ),
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [32, 6, 98, 26] 
              }
            },
            {
              "id":  getID( "card" ),
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/1200x/9c/07/17/9c0717873227bbac64c15b84b3802e3f.jpg"
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Манихей" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Подпермышкин-Фиговинский" 
              },
              "description": {
                "id":  getID( "" ),
                "data": "Этим гражданином принято решение баллотироваться в генерал-губернаторы. Пускай Папуа вздрогнет."
              },
              "roles": { 
                "id":  getID( "" ),
                "data": [{ "_id": "8-21", "title": "Минорик" }] 
              },
              "divider": {
                "id":  getID( "" ),
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [48, 42, 87, 93] 
              }
            },
            {
              "id":  getID( "card" ),
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/00/a5/9f/00a59f8bf6f5d71e46a3f96d970e73c7.jpg"
              },
              "description": {
                "id":  getID( "" ),
                "data": "американский киноактёр. Американский институт киноискусства назвал Бугурда лучшим актёром в истории американского кино. Сменив несколько занятий, в 1921 году Бугурд стал актёром"
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Хамфри" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Бугурд" 
              },
              "divider": {
                "id":  getID( "" ),
              },
              "roles": {
                "id":  getID( "" ),
                "data": [
                  { "_id": "8-31", "title": "Актёр" },
                  { "_id": "8-32", "title": "Мастадонт" },
                  { "_id": "8-33", "title": "Коллекционер суккулентов" }
                ]
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [99, 11, 43, 65] 
              }
            },
            {
              "id":  getID( "card" ),
              "avatar": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "avatarMedallion": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "background": {
                "id":  getID( "" ),
                "data": "https://i.pinimg.com/736x/ee/06/8a/ee068ac2a400dae766f93268f8fc8dd6.jpg"
              },
              "description": {
                "id":  getID( "" ),
                "data": "На Валдае неадекватно отреагировала на вызов, что вызвало удивление. Ещё чего-то -- натравила народ на всю австралийскую колбасу."
              },
              "first_name": { 
                "id":  getID( "" ),
                "data": "Жермондина" 
              },
              "last_name": { 
                "id":  getID( "" ),
                "data": "Кудахткина" 
              },
              "roles": {
                "id":  getID( "" ),
                "data": [
                  { "_id": "8-11", "title": "Клошарик-1" },
                  { "_id": "8-11-4", "title": "Шераховатый" }
                ]
              },
              "divider": {
                "id":  getID( "" ),
              },
              "links": {
                "id":  getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id":  getID( "" ),
                "data": [99, 11, 43, 65]
              }
            }
          ],
          defaultTitle: "Полноразмерные портреты"
        },
        {
          "animated": ANIMATED_STYLE.FADE_IN_LEFT,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "id":  getID( "personal_cards" ),
          "type": LANDING_TYPE_CONTENT.PERSONAL_CARDS,
          "order": [
            "avatar",
            "order",
            "first_name",
            "last_name",
            "description",
            "links",
            "roles"
          ],
          "feedType": "carousel",
          "is_nagination": 1,
          "design_type": 3,
          columns: 2,
          "cards": [
            {
              "id": getID( "personal_card" ),
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/f6/6d/a6/f66da646f9f6d37024f0ca275d15ba09.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
              },
              "first_name": { 
                "id": getID( "" ),"data": "Мустандил Исакович" 
              },
              "last_name": {
                "id": getID( "" ),
                 "data": "Пляйстнер" 
                },
              "roles": {
                "id": getID( "" ),
                "data": [
                  { "_id": "8-11-11", "title": "Нежданчик" },
                  { "_id": "8-11-1134", "title": "Барин-сударин" }
                ]
              },
              "description": {
                "id": getID( "" ),
                "data": "В этом человеке что-то есть. Прекрасно понимает, что ему объявили войну. И Запад через свою пятую колонну жмёт ему на тормоза."
              },
              "divider": {
                "id": getID( "" ),
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [32, 6, 98, 26] 
              }
            },
            {
              "id": getID( "personal_card" ),
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/36/f0/50/36f050240b8f7764dc6dfb20f92c2566.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/17/21/12/172112d7e438eb485655dd23110d2a3d.jpg"
              },
              "first_name": {
                "id": getID( "" ),
                "data": "Авдотья" 
              },
              "last_name": { 
                "id": getID( "" ), 
                "data": "Пурпышкина" 
              },
              "roles": {
                "id": getID( "" ),
                "data": [
                  { "_id": "8-11", "title": "Колдовская колдунька" },
                  { "_id": "8-11-77", "title": "Барыня-сударыня" }
                ]
              },
              "description": {
                "id": getID( "" ),
                "data": "Женское обаяние 12 уровня. Во-первых, проверит паспорт. Потом даст пропуск. Я-то знаю... Положа руку на сердцЕ."
              },
              "divider": {
                "id": getID( "" ),
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [48, 42, 87, 93] 
              }
            },
            {
              "id": getID( "personal_card" ),
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/55/47/b8/5547b80a1390a68daebb679711fe10b0.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/e6/52/d4/e652d435d75040a0ba0b6b5802e66e9e.jpg"
              },
              "first_name": { 
                "id": getID( "" ),
                "data": "Дед Пердед" 
              },
              "last_name": { 
                "id": getID( "" ),
                "data": "Шелковистов" 
              },
              "roles": { 
                "id": getID( "" ),
                "data": [{ "_id": "8-11", "title": "Конторщик" }] 
              },
              "description": {
                "id": getID( "" ),
                "data": "Ловелас и проныра. На прошлом эфире сообщил публике о своей помолвке. Сложная система компромиссов с его дамой сердца достигнута. Наконец-то мы все вздохнём с облегчением."
              },
              "divider": {
                "id": getID( "" ),
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/15657593352371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [32, 6, 98, 26] 
              }
            },
            {
              "id": getID( "personal_card" ),
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/13/38/11/133811de9fe388d4f4057c7461fb6bac.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/9c/07/17/9c0717873227bbac64c15b84b3802e3f.jpg"
              },
              "first_name": { 
                "id": getID( "" ),
                "data": "Манихей" 
              },
              "last_name": { 
                "id": getID( "" ),
                "data": "Подпермышкин-Фиговинский" 
              },
              "description": {
                "id": getID( "" ),
                "data": "Этим гражданином принято решение баллотироваться в генерал-губернаторы. Пускай Папуа вздрогнет."
              },
              "roles": { 
                "id": getID( "" ),
                "data": [{ "_id": "8-21", "title": "Минорик" }] 
              },
              "divider": {
                "id": getID( "" ),
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [48, 42, 87, 93] 
              }
            },
            {
              "id": getID( "personal_card" ),
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/00/a5/9f/00a59f8bf6f5d71e46a3f96d970e73c7.jpg"
              },
              "description": {
                "id": getID( "" ),
                "data": "американский киноактёр. Американский институт киноискусства назвал Бугурда лучшим актёром в истории американского кино. Сменив несколько занятий, в 1921 году Бугурд стал актёром"
              },
              "first_name": { 
                "id": getID( "" ),
                "data": "Хамфри" 
              },
              "last_name": { 
                "id": getID( "" ),
                "data": "Бугурд" 
              },
              "divider": {
                "id": getID( "" ),
              },
              "roles": {
                "id": getID( "" ),
                "data": [
                  { "_id": "8-31", "title": "Актёр" },
                  { "_id": "8-32", "title": "Мастадонт" },
                  { "_id": "8-33", "title": "Коллекционер суккулентов" }
                ]
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [99, 11, 43, 65] 
              }
            },
            {
              "id": getID( "personal_card" ),
              "avatar": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/80/41/e5/8041e5e7c35428de032d657961f63c15.jpg"
              },
              "avatarMedallion": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/70/02/2a/70022aab0e3638ac1e7787573d96881d.jpg"
              },
              "background": {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/ee/06/8a/ee068ac2a400dae766f93268f8fc8dd6.jpg"
              },
              "description": {
                "id": getID( "" ),
                "data": "На Валдае неадекватно отреагировала на вызов, что вызвало удивление. Ещё чего-то -- натравила народ на всю австралийскую колбасу."
              },
              "first_name": { 
                "id": getID( "" ),
                "data": "Жермондина" 
              },
              "last_name": { 
                "id": getID( "" ),
                "data": "Кудахткина" 
              },
              "roles": {
                "id": getID( "" ),
                "data": [
                  { "_id": "8-11", "title": "Клошарик-1" },
                  { "_id": "8-11-4", "title": "Шераховатый" }
                ]
              },
              "divider": {
                "id": getID( "" ),
              },
              "links": {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933526371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              "statistic_line": { 
                "id": getID( "" ),
                "data": [99, 11, 43, 65] 
              }
            }
          ],
            defaultTitle: "Архивные карточки"
        }
    ]
}